import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useGetNewSession } from '#src/app/shared/hooks/session';
import { useTrackOnce } from '#src/app/shared/hooks/tracking';
import type { SuccessfulLoginOrJoinTrackingParams } from '#src/app/shared/utils/loginOrJoin';
import { getSuccessfulLoginOrJoinTrackingProps } from '#src/app/shared/utils/loginOrJoin';

type UseTrackSuccessfulLoginOrJoinParams = {
	trackSuccessfulLoginOrJoin: (params: SuccessfulLoginOrJoinTrackingParams) => Promise<void>;
};

export function useTrackSuccessfulLoginOrJoin(): UseTrackSuccessfulLoginOrJoinParams {
	const { facebook } = useUtilityContext();
	const trackSignup = useTrackOnce();
	const trackLoginOrJoin = useTrackOnce();
	const getNewSession = useGetNewSession();

	const trackSuccessfulLoginOrJoin = async (params: SuccessfulLoginOrJoinTrackingParams): Promise<void> => {
		const { newUser, userId } = params;
		let currentUserId;
		// Only query a fresh session if we need updated user data
		if (userId) {
			currentUserId = userId;
		} else {
			try {
				const updatedSession = await getNewSession();
				currentUserId = updatedSession.user?.id;
			} catch (e) {
				// do nothing
			}
		}
		// eslint-disable-next-line @typescript-eslint/naming-convention
		const { user_id, ...trackingParams } = getSuccessfulLoginOrJoinTrackingProps({
			...params,
			facebook,
			userId: currentUserId,
		});
		if (newUser) {
			void trackSignup('signup', trackingParams, { defaultOverrides: { user_id } });
		}
		void trackLoginOrJoin('successful_login_or_join', trackingParams, { defaultOverrides: { user_id } });
	};

	return {
		trackSuccessfulLoginOrJoin,
	};
}
